import script from "./SliderHome.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderHome.vue?vue&type=script&setup=true&lang=js"

import "./SliderHome.vue?vue&type=style&index=0&id=c2893808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2893808"]])

export default __exports__